import api from './../../../utils/api';
// import api from './../../../utils/mock-api';
import types from './types';

const LOGGED_IN = 'Auth/loggedIn';

export default {
  async [types.actions.FETCH_ROOMS] ({commit, getters, rootGetters, dispatch}, weekId) {
    console.log('Action: FETCH ROOMS');

    if (getters.isFetching()) {
      return;
    }

    if (getters.getRooms()) {
      return;
    }

    const loggedIn = rootGetters[LOGGED_IN]()
    if (loggedIn) {
      console.log('Action: FETCH ROOMS logged in');
      try {
        commit(types.mutations.FETCHING_ROOMS)
        const response = await api.getRooms()
        commit(types.mutations.RECEIVE_ROOMS, response.data)
      } catch (error) {
        console.log('Action: FETCH ROOMS error', error);
        // Try to auth and get again
        try {
          console.log('Action: FETCH ROOMS try auth');
          await dispatch('Auth/authRefresh', null, {root: true})
          console.log('Action: FETCH ROOMS try fetch again');

          commit(types.mutations.FETCHING_ROOMS)
          const response = await api.getRooms()
          commit(types.mutations.RECEIVE_ROOMS, response.data)
        } catch (error) {
          // still error after auth
          console.log('FETCH_ROOMS error inner:', error);
          // reject()
        }
      }
    } else {
      console.log('Action: FETCH ROOMS not logged in');
      throw new Error('Fetch error: not logged in');
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/room/actions.js